import { useEffect, useRef, useState } from "react";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { BodyDiv } from "../../components/components-style";
import AppLayout, { MainBody } from "../../components/layout/app/layout";
import {
  CaptionText,
  LittleSubHeadline,
  TextBody,
} from "../../components/typography";
import Headline from "../../components/ui/headline";
import Input from "../../components/ui/inputs";
import {
  EndpointsEnum,
  NameIdType,
  prioritiesObj,
  PriorityEnum,
  ProjectMember,
} from "../../assets/utils/enums/project";
import styled from "styled-components";
import { Button } from "../../components/ui/button";
import { COLORS } from "../../assets/utils/enums/colors";
import Dropdown from "../../components/ui/dropdown";
import { DropdownTypeEnum } from "../../assets/utils/enums/table";
import getData from "../../api/project-request";
import plusIcon from "../../assets/images/icons/circle-add-project.svg";
import minusIcon from "../../assets/images/icons/circle-minus-project.svg";
import { motion, AnimatePresence } from "framer-motion";
import { useFormValidation } from "../../assets/utils/hooks/useFormsValidation";
import { validateProject } from "../../assets/utils/validation/form/validator";
import { ValidationFormsModeEnum } from "../../assets/utils/validation/form/types";
import ErrorBlock from "../../components/ui/error-text";
import CustomToast from "../../components/ui/custom-toast";
import toast from "react-hot-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import { currencies } from "../../assets/utils/data/items";
import {
  API_URL_COMPANY,
  API_URL_CONTACT,
  API_URL_PRIORITY,
  API_URL_PROJECT,
  API_URL_SELLING,
} from "../../constants";
import { authFetch } from "../../api/authFetch";
import { useLocation, useNavigate } from "react-router-dom";
import DeadlinePicker from "../../components/ui/deadline-picker";
import { formatIOS } from "../../assets/utils/date-formatter";
import { findStructureFieldByKey, shouldRenderField, useStructureStore } from "../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../assets/utils/enums/basket";

export default function AddProjectPage() {
  const location = useLocation();
  const prefilledData =
    (location.state as {
      name?: string;
      description?: string;
      budget?: string;
      responsibleContact?: string;
      client?: string;
      company?: string;
      sellingId?: number;
    }) ?? null;
  const [name, setName] = useState<string>("");
  const [client, setClient] = useState<string>("");
  const [responsibleContact, setResponsibleContact] = useState<string>("");
  const [budget, setBudget] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [priority, setPriority] = useState<string>(PriorityEnum.LOW);
  const [stage, setStage] = useState<string>("");
  const [deadline, setDeadline] = useState<string>("");
  const [currency, setCurrency] = useState<string>(currencies[1].symbol);
  const [selling, setSelling] = useState<NameIdType>({ id: "", name: "" });
  const [sellingQuery, setSellingQuery] = useState<string>("");

  const [members, setMembers] = useState<ProjectMember[]>([
    { email: "", roleName: "", fullName: "" },
  ]);
  const [priorities, setPriorities] = useState<NameIdType[]>([]);
  const [filterClients, setFilterClients] = useState<
    { id: number; fullName: string; email: string }[]
  >([]);
  const [filterSellings, setFilterSellings] = useState<NameIdType[]>([]);
  const [filterResponsible, setFilterResponsible] = useState<
    { fullName: string; email: string }[]
  >([]);
  const [filterCompanies, setFilterCompanies] = useState<
    { id: number; name: string; responsibleEmail: string }[]
  >([]);
  const [responsibleForMembers, setResponsibleForMembers] = useState<
    { fullName: string; email: string }[]
  >([]);

  const navigate = useNavigate();
  const fields = useStructureStore(
    (s) => s.structures[ObjectsEnum.PROJECTS].fields
  )
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { errors, validate } = useFormValidation(validateProject);

  const hasShownToastRef = useRef(false);

  useEffect(() => {
    if (!prefilledData) return;
    if (hasShownToastRef.current) return;

    hasShownToastRef.current = true;

    toast((t) => (
      <CustomToast
        t={t}
        type={ToastTypeEnum.INFO}
        text={"Дані для проєкту попередньо заповнені з продажу!"}
      />
    ));

    if (prefilledData.name) setName(prefilledData.name);
    if (prefilledData.description) setDescription(prefilledData.description);

    if (prefilledData.budget) {
      setBudget(prefilledData.budget.slice(2).replaceAll(" ", ""));
      setCurrency(prefilledData.budget.slice(0, 1));
    }

    if (prefilledData.sellingId) {
      setSelling({ id: prefilledData.sellingId.toString(), name: "" })
    }

    if (prefilledData.client) setClient(prefilledData.client);
    if (prefilledData.company) setCompany(prefilledData.company);
    if (prefilledData.responsibleContact)
      setResponsibleContact(prefilledData.responsibleContact);

    // window.history.replaceState({}, document.title);
  }, [prefilledData]);

  useEffect(() => {
    const getClients = async () => {
      const data = await getData(`${API_URL_CONTACT}/search?query=${client}`);
      setFilterClients(data.slice(0, 4));
    };
    const getCompanies = async () => {
      const data = await getData(`${API_URL_COMPANY}/search?query=${company}`);
      setFilterCompanies(data.slice(0, 4));
    };
    const getResponsibleUsers = async () => {
      const data = await getData(
        `${API_URL_PROJECT}/${EndpointsEnum.RESPONSIBLE_USER}?query=${responsibleContact}`
      );
      setFilterResponsible(data.slice(0, 4));
    };
    const getMembersUsers = async () => {
      const data = await getData(
        `${API_URL_PROJECT}/${EndpointsEnum.RESPONSIBLE_USER}?query=`
      );
      setResponsibleForMembers(data.slice(0, 4));
    };
    getClients();
    getCompanies();
    getResponsibleUsers();
    getMembersUsers();

    const getPriorities = () => {
      setIsLoading(true);
      setTimeout(async () => {
        const data = await getData(`${API_URL_PRIORITY}/get-all`);
        setPriorities(data);
        setIsLoading(false);
      }, 50);
    };
    getPriorities();
  }, [client, company, responsibleContact, prefilledData?.client, prefilledData?.company, prefilledData?.responsibleContact]);

  useEffect(() => {
    setIsLoading(true);
    if (sellingQuery !== selling.name) {
      setSelling({ id: "", name: "" });
    }
    const getSellings = async () => {
      try {
        const data = await getData(
          `${API_URL_SELLING}/search-by?query=${sellingQuery}`
        );
        setFilterSellings(Array.isArray(data) ? data.slice(0, 3) : []);
      } catch {
        setFilterSellings([]);
      } finally {
        setIsLoading(false);
      }
    };

    getSellings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellingQuery]);

  useEffect(() => {
    // автозаповнення компанії, якщо компанія введена повністю

    const getCompanyByClient = async (id: number) => {
      const data = await getData(`${API_URL_CONTACT}/${id}/company`);

      if (data) {
        setCompany(data.company?.name ?? "");
      } else {
        setClient("");
      }
    };
    const exactClient = filterClients.find((x) => x.email === client);
    if (exactClient) {
      getCompanyByClient(exactClient.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, prefilledData?.client]);

  useEffect(() => {
    // автозаповнення клієнта, якщо компанія введена повністю
    const getClientByCompany = async (id: number) => {
      const data = await getData(`${API_URL_COMPANY}/${id}/main-contact`);
      if (data) {
        setClient(data.contact.email);
      } else {
        setCompany("");
      }
    };

    const exactCompany = filterCompanies.find((x) => x.name === company);
    if (exactCompany) {
      getClientByCompany(exactCompany.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, prefilledData?.company]);

  const handleAdd = () => {
    setMembers([
      ...members,
      { email: "", roleName: "", filteredResponsible: responsibleForMembers },
    ]);
  };

  const handleRemove = (index: number) => {
    setMembers(members.filter((_, i) => i !== index));
  };

  const handleChange = async (
    index: number,
    field: "email" | "roleName",
    value: string
  ) => {
    const updated = [...members];
    updated[index][field] = value;

    // якщо введено хоча б 1 символ, робимо запит
    if (field === "email") {
      const data = await getData(
        `${API_URL_PROJECT}/${EndpointsEnum.RESPONSIBLE_USER}?query=${value}`
      );
      updated[index].filteredResponsible = data.slice(0, 4);
    }

    setMembers(updated);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);

      const { hasErrors } = validate(
        {
          name,
          client,
          company,
          description,
          deadline,
          budget,
          responsibleContact,
          priority,
          stage,
          members,
        },
        ValidationFormsModeEnum.ADD
      );

      if (hasErrors) return;

      const response = await authFetch(`${API_URL_PROJECT}/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name,
          description: description,
          companyId: !findStructureFieldByKey(fields, "companyName")?.visible ? null :
            filterCompanies.find((x) => x.name === company)?.id || null,
          valutaCode:
            currencies.find((x) => x.symbol === currency)?.code || "UAH",
          budget: Number.parseInt(budget),
          deadline: formatIOS(deadline),
          priorityName: priority,
          projectStageName: stage,
          responsibleUserEmail: responsibleContact,
          clientContactEmail: client,
          usersAdd: members,
          sellingId: Number.parseInt(selling.id) || null,
        }),
        credentials: "include",
      });

      if (!response.ok) {
        toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.WARNING}
            text={"Перевірте коректність введення даних!"}
          />
        ));
        return;
      }
      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.SUCCESS}
          text={"Дані введені коректно, проєкт доданий!"}
        />
      ));
      setTimeout(() => {
        navigate("/projects/main");
      }, 300);
    } catch (error) {
      console.error("Fetch error:", error);
      toast((t) => (
        <CustomToast
          t={t}
          text={"Упс, щось пішло не так\nПроблема з сервером."}
          type={ToastTypeEnum.ERROR}
        />
      ));
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 150);
    }
  };

  return (
    <AppLayout
      className="d-flex flex-column align-items-center"
      blockType={"item-form"}
      loaderState={isLoading}
    >
      <Headline
        headline={HeadlineTypeEnum.PROJECTS}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Повернутися до Проєктів"
        btn_link="/projects/main"
      />
      <MainBody className="align-items-stretch">
        <BodyDiv
          data-class="add-block"
          className="d-flex flex-column align-items-center"
        >
          <CaptionText>Основні дані про проєкт</CaptionText>
          <div className="w-100">
            {shouldRenderField(findStructureFieldByKey(fields, "name")) && <Input
              attribute="nameOfProject"
              value={name}
              setValue={setName}
              errorText={errors.name}
              label={findStructureFieldByKey(fields, "name")?.label ?? "Назва *"}
              placeholder="Введіть назву проєкту"
            />}

            {shouldRenderField(findStructureFieldByKey(fields, "deadline")) && <DeadlinePicker label={findStructureFieldByKey(fields, "deadline")?.label} value={deadline} setValue={setDeadline} />}
            {errors.deadline && <ErrorBlock errorText={errors.deadline} />}
            <span className="w-100 d-flex gap-sm-3 flex-sm-row flex-column">
              {shouldRenderField(findStructureFieldByKey(fields, "contactEmail")) && <Input
                attribute="client"
                value={client}
                setValue={setClient}
                errorText={errors.client}
                label={findStructureFieldByKey(fields, "contactEmail")?.label ?? "Клієнт"}
                contactsArr={filterClients}
                placeholder="Введіть пошту / ім’я"
              />}
              {shouldRenderField(findStructureFieldByKey(fields, "companyName")) && <Input
                attribute="company"
                value={company}
                setValue={setCompany}
                errorText={errors.company}
                companyArr={filterCompanies}
                label={findStructureFieldByKey(fields, "companyName")?.label ?? "Компанія"}
                placeholder="Введіть назву компанії"
              />}
            </span>
            {shouldRenderField(findStructureFieldByKey(fields, "selling")) && <Input
              attribute={DropdownTypeEnum.SELLINGS}
              item={selling}
              setItem={setSelling}
              value={sellingQuery}
              setValue={setSellingQuery}
              errorText={errors.selling}
              itemsNameIdArr={filterSellings}
              label={findStructureFieldByKey(fields, "selling")?.label ?? "Продажі"}
              placeholder="Введіть назву"
            />}
            {shouldRenderField(findStructureFieldByKey(fields, "budget")) && <Input
              attribute="budget"
              value={budget}
              setValue={setBudget}
              errorText={errors.budget}
              currency={currency}
              setCurrency={setCurrency}
              label={findStructureFieldByKey(fields, "budget")?.label ?? "Бюджет"}
              placeholder="Введіть значення"
            />}
          </div>
        </BodyDiv>
        <BodyDiv data-class="add-block-other">
          {shouldRenderField(findStructureFieldByKey(fields, "responsibleEmail")) && <span className="w-100 d-flex flex-column align-items-center">
            <CaptionText>{findStructureFieldByKey(fields, "responsibleEmail")?.label ?? "Відповідальний контакт"}</CaptionText>
            <Input
              attribute="contact"
              value={responsibleContact}
              setValue={setResponsibleContact}
              errorText={errors.responsibleContact}
              label=""
              contactsArr={filterResponsible}
              placeholder="Введіть пошту / ім’я"
            />
          </span>}
          {shouldRenderField(findStructureFieldByKey(fields, "priorityName")) && <span className="w-100 d-flex flex-column align-items-center">
            <CaptionText>{findStructureFieldByKey(fields, "priorityName")?.label ?? "Пріоритет"}</CaptionText>
            <GeneralItemBlock>
              {priorities.map((item: NameIdType) => {
                const isActive: boolean = priority === item.name;
                return (
                  <Button
                    key={item.id}
                    bgcolor={
                      isActive
                        ? prioritiesObj[item.name as PriorityEnum].bgColor
                        : "transparent"
                    }
                    txtcolor={
                      isActive
                        ? prioritiesObj[item.name as PriorityEnum].txColor
                        : COLORS["bg-text-color"]
                    }
                    brcolor={
                      isActive
                        ? prioritiesObj[item.name as PriorityEnum].bgColor
                        : COLORS["bg-text-color"]
                    }
                    width="100%"
                    type="large"
                    brradius="24px"
                    className="justify-content-between"
                    onClick={() => {
                      setPriority(item.name);
                    }}
                  >
                    <TextBody>{item.name as PriorityEnum}</TextBody>
                    {isActive && (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 32 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clipRule="evenodd"
                          d="M28.708 8.70799L14.708 22.708C14.6151 22.8011 14.5048 22.875 14.3833 22.9254C14.2618 22.9758 14.1315 23.0018 14 23.0018C13.8685 23.0018 13.7382 22.9758 13.6167 22.9254C13.4952 22.875 13.3849 22.8011 13.292 22.708L5.29199 14.708L6.70799 13.292L14 20.586L27.294 7.29199L28.708 8.70799Z"
                          fill={
                            isActive
                              ? prioritiesObj[item.name as PriorityEnum].txColor
                              : "transparent"
                          }
                        />
                      </svg>
                    )}
                  </Button>
                );
              })}
            </GeneralItemBlock>
          </span>}
          {shouldRenderField(findStructureFieldByKey(fields, "projectStageName")) && <span className="w-100 d-flex flex-column">
            <CaptionText className="pb-2 text-center">{findStructureFieldByKey(fields, "projectStageName")?.label ?? "Статус"}</CaptionText>
            <Dropdown
              checkedValue={stage}
              setChecked={setStage}
              type={DropdownTypeEnum.STAGE}
            />
            {errors.stage && <ErrorBlock errorText={errors.stage} />}
          </span>}
          {shouldRenderField(findStructureFieldByKey(fields, "description")) && <span className="w-100 d-flex flex-column">
            <CaptionText className="text-center">{findStructureFieldByKey(fields, "description")?.label ?? "Опис"}</CaptionText>
            <Input
              attribute="description"
              value={description}
              setValue={setDescription}
              errorText={""}
              label=""
              placeholder="Введіть опис проєкту"
            />
          </span>}
        </BodyDiv>
      </MainBody>
      {shouldRenderField(findStructureFieldByKey(fields, "team-members")) && <BodyDiv
        data-class="add-block-members"
        className="d-flex flex-column align-items-start"
      >
        <span className="d-flex align-items-center justify-content-between w-100">
          <CaptionText>{findStructureFieldByKey(fields, "team-members")?.label ?? "Додати учасників цього проєкту"}</CaptionText>
          <AddIconBtn src={plusIcon} alt="add-icon" onClick={handleAdd} />
        </span>
        <AnimatePresence>
          {members.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="w-100"
            >
              <AddMemberItem key={index}>
                <AddMemberBody>
                  <Input
                    attribute="members"
                    value={member.email}
                    setValue={(val) =>
                      handleChange(index, "email", val as string)
                    }
                    errorText=""
                    label=""
                    contactsArr={
                      member.filteredResponsible || responsibleForMembers
                    }
                    placeholder="Введіть пошту / ім’я"
                  />
                  <Dropdown
                    checkedValue={member.roleName}
                    setChecked={(val) =>
                      handleChange(index, "roleName", val as string)
                    }
                    type={DropdownTypeEnum.PROJECT_ROLES}
                  />
                </AddMemberBody>
                <AddIconBtn
                  src={minusIcon}
                  alt="minus-icon"
                  onClick={() => handleRemove(index)}
                />
              </AddMemberItem>
            </motion.div>
          ))}
        </AnimatePresence>
        {errors.members && <ErrorBlock errorText={errors.members} />}
      </BodyDiv>}
      <Button
        bgcolor={COLORS.secondary1}
        txtcolor={COLORS.white}
        brcolor={"transparent"}
        width="30%"
        className="center-btn"
        brradius="24px"
        type="large"
        onClick={handleSave}
      >
        <LittleSubHeadline>Зберегти зміни</LittleSubHeadline>
      </Button>
    </AppLayout>
  );
}

export const AddMemberBody = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const AddIconBtn = styled.img`
  transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1);
  width: 32px;
  height: 32px;
  cursor: pointer;
  &:active {
    transform: scale(0.9);
  }
`;

export const AddMemberItem = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
  width: 100%;
  ${AddIconBtn} {
    margin-top: 8px;
  }
`;

export const GeneralItemBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  /* gap: 4px; */
  align-items: center;
  padding-top: 8px;
  width: 100%;
  ${Button} {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 8px 24px;
    border-width: 2px;
    svg {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
`;
